import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { columnDefaultV0Schema } from './v0';
import { columnLegacyV0Schema } from '../legacy/entity';
import { migrateLegacyDefaultToV0 } from '../legacy/migration';

export const DefaultColumnEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: columnDefaultV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: columnLegacyV0Schema, up: migrateLegacyDefaultToV0 }],
});

export type DefaultColumn = InferredEntity<typeof DefaultColumnEntitySchema>;
